// extracted by mini-css-extract-plugin
export default {"tabGdp":"Tab_tabGdp__DXfUc","tabItemGdp":"Tab_tabItemGdp__+LF0K"};